import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getGitlabActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({gitlab}: BackupState) => gitlab.actions);
export const getGitlabActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({gitlab}: BackupState) => gitlab.totalActions);
export const isGitlabActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({gitlab}: BackupState) => gitlab.loading);
export const getGitlabCanRestore = createSelector((state: DefaultRootState) => state.backups, ({gitlab}: BackupState) => gitlab.canRestore);
